'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _FolderOpenOutlined = _interopRequireDefault(require('./lib/icons/FolderOpenOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _FolderOpenOutlined;
exports.default = _default;
module.exports = _default;